// A search picker opened as its own page (search_pickers/show) gets its select
// and hands its choices back through session storage, since the picker's page
// and the page that opened it share the native modal's web view.
export const PAGE_HANDOFF_KEY = "search-picker-page"
export const PAGE_RESULT_KEY = "search-picker-page-result"

export function readStored(key) {
  try {
    return JSON.parse(sessionStorage.getItem(key))
  } catch {
    return null
  }
}

// Turbo forgets a visit once it completes, which a snapshot restore does
// before the restored page's controllers can ask how they got there.
let lastVisitAction = null
document.addEventListener("turbo:visit", event => { lastVisitAction = event.detail.action })

export function restoredByVisit() {
  return lastVisitAction === "restore"
}
